import React from "react";
import { useParams } from "react-router-dom";
import {
    Paper,
    Box,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Divider
} from "@mui/material";
import Header from "../../Header";
import Footer from "../../Footer";
import Grid from "@mui/material/Grid2";
import { Iconify } from "../../Minimal/src/components/iconify/iconify";

const TaxInvoiceView = () => {
    const { id } = useParams();

    const invoiceData = {
        companyName: "Ebusso",
        companyTel: "447585591189",
        companyVAT: "123456",
        companyRegNo: "7363627",
        bankAccount: "111111111",
        sortCode: "222222",
        customerName: "BECCLES SERVICES LTD",
        address: "Beccles rd Norwich",
        deliveryAddress: "Deliver to BP Shoebury ss1 3rs,",
        postcode: "1AE 627A",
        tel: "7276617342",
        email: "surajbang26@gmail.com",
        orderDate: "2025-10-16 08:11:39",
        products: [
            {
                id: 1,
                description: "15L FLAVOIL SUNFLOWER OIL (COOKING OIL) | 12x30g",
                qty: 1,
                type: "Box",
                unitPrice: 9.00,
                discount: 0.00,
                vatAmount: 1.80,
                netAmount: 9.00,
                isFree: false,
                isDiscounted: false
            },
            {
                id: 2,
                description: "15L FLAVOIL SUNFLOWER OIL (COOKING OIL) | 12x30g",
                qty: 1,
                type: "Box",
                unitPrice: 9.00,
                originalPrice: 9.00,
                discount: 0.00,
                vatAmount: 1.80,
                netAmount: 9.00,
                isFree: true,
                isDiscounted: false
            },
            {
                id: 3,
                description: "15L FLAVOIL SUNFLOWER OIL (COOKING OIL) | 12x30g",
                qty: 1,
                type: "Box",
                unitPrice: 4.00,
                originalPrice: 9.00,
                discount: 0.00,
                vatAmount: 1.80,
                netAmount: 9.00,
                isFree: false,
                isDiscounted: true
            },
            {
                id: 4,
                description: "15L FLAVOIL SUNFLOWER OIL (COOKING OIL) | 12x30g",
                qty: 1,
                type: "Box",
                unitPrice: 9.00,
                discount: 0.00,
                vatAmount: 1.80,
                netAmount: 9.00,
                isFree: false,
                isDiscounted: false
            },
            {
                id: 5,
                description: "15L FLAVOIL SUNFLOWER OIL (COOKING OIL) | 12x30g",
                qty: 1,
                type: "Box",
                unitPrice: 9.00,
                discount: 0.00,
                vatAmount: 1.80,
                netAmount: 9.00,
                isFree: false,
                isDiscounted: false
            }
        ],
        totals: {
            totalStdGoods: 9.00,
            vatAmount: 1.80,
            totalZeroGoods: 0.00,
            promotionalDiscount: 0.00,
            orderDiscount: 0.00,
            invoiceTotal: 10.80
        }
    };

    return (
        <div>
            <Header />
            <Box className="main-container position-relative" sx={{ backgroundColor: "#F8F8F8", minHeight: "calc(100vh - 32px)" }}>
                <Box className="container-fluid" sx={{ marginTop: "56px" }}>
                    <Paper variant="elevation" elevation={2} sx={{ p: 3, mb: 3 }}>

                        <Box sx={{ mb: 3 }}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 600, color: "text.primary" }}>
                                        Tax Invoice
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                    >
                                        Print Invoice
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: "text.primary" }}>
                                Company Details
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{invoiceData.companyName}</Typography>
                                        <Typography display="flex" alignItems="center" gap={0.5}>
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>Tel: </Typography>
                                            <Typography variant="caption">{invoiceData.companyTel}</Typography>
                                        </Typography>
                                        <Typography display="flex" alignItems="center" gap={0.5}>
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>VAT No: </Typography>
                                            <Typography variant="caption">{invoiceData.companyVAT}</Typography>
                                        </Typography>
                                        <Typography display="flex" alignItems="center" gap={0.5}>
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>Company Registration No: </Typography>
                                            <Typography variant="caption">{invoiceData.companyRegNo}</Typography>
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                                        <Typography variant="caption" fontWeight={600}>Please Phone The Office To Pay By Credit / Debit Card</Typography>
                                        <Typography display="flex" alignItems="center" gap={0.5}>
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>Bank A/C: </Typography>
                                            <Typography variant="caption">{invoiceData.bankAccount}</Typography>
                                        </Typography>
                                        <Typography display="flex" alignItems="center" gap={0.5}>
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>Sort Code: </Typography>
                                            <Typography variant="caption">{invoiceData.sortCode}</Typography>
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>

                        <Divider sx={{ borderStyle: "dashed", my: 2,borderColor: "#000000a3" }} />

                        <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: "text.primary" }}>
                                Customer Details
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                                        <Typography variant="caption">{invoiceData.customerName}</Typography>
                                        <Typography variant="caption">{invoiceData.address}</Typography>
                                        <Typography variant="caption">{invoiceData.deliveryAddress}</Typography>
                                        <Typography variant="caption">{invoiceData.postcode}</Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                                        <Typography display="flex" alignItems="center" gap={0.5}>
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>Tel: </Typography>
                                            <Typography variant="caption">{invoiceData.tel}</Typography>
                                        </Typography>
                                        <Typography display="flex" alignItems="center" gap={0.5}>
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>Email: </Typography>
                                            <Typography variant="caption">{invoiceData.email}</Typography>
                                        </Typography>
                                        <Typography display="flex" alignItems="center" gap={0.5}>
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>Order Date: </Typography>
                                            <Typography variant="caption">{invoiceData.orderDate}</Typography>
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>

                        <Divider sx={{ borderStyle: "dashed", mb: 2 }} />

                        <TableContainer sx={{ mb: 3, overflowX: "auto", mx: -3, width: "calc(100% + 48px)" }}>
                            <Table size="small" sx={{ minWidth: 650, width: "100%" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", width: "40%" }}>Product Description</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 600, fontSize: "0.75rem", width: "8%" }}>Qty</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 600, fontSize: "0.75rem", width: "10%" }}>Type</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 600, fontSize: "0.75rem", width: "12%" }}>Unit Price</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 600, fontSize: "0.75rem", width: "10%" }}>Discount %</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 600, fontSize: "0.75rem", width: "10%" }}>VAT Amount</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 600, fontSize: "0.75rem", width: "10%" }}>Net Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invoiceData.products.map((product) => (
                                        <TableRow key={product.id}>
                                            <TableCell sx={{ fontSize: "0.75rem" }}>
                                                <Typography variant="caption" sx={{ display: "block" }}>{product.description}</Typography>
                                                {product.isFree && (
                                                    <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
                                                        <Iconify
                                                            icon="solar:circle-bold"
                                                            width={6}
                                                            sx={{ color: "info.main", mr: 0.5 }}
                                                        />
                                                        <Typography variant="caption" display="flex" alignItems="center" gap={0.5} sx={{ color: "info.dark", fontSize: "0.7rem" }}>
                                                            <Iconify icon="solar:check-circle-bold" width={12} />
                                                         (F)
                                                        </Typography>
                                                    </Box>
                                                )}
                                                {product.isDiscounted && (
                                                    <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
                                                        <Iconify
                                                            icon="solar:circle-bold"
                                                            width={6}
                                                            sx={{ color: "info.main", mr: 0.5 }}
                                                        />
                                                        <Typography variant="caption" display="flex" alignItems="center" gap={0.5} sx={{ color: "info.dark", fontSize: "0.7rem" }}>
                                                            <Iconify icon="solar:check-circle-bold" width={12} />
                                                            (P)
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </TableCell>
                                            <TableCell align="center" sx={{ fontSize: "0.75rem" }}>
                                                <Typography variant="caption">{product.qty}</Typography>
                                            </TableCell>
                                            <TableCell align="center" sx={{ fontSize: "0.75rem" }}>
                                                <Typography variant="caption">{product.type}</Typography>
                                            </TableCell>
                                            <TableCell align="right" sx={{ fontSize: "0.75rem" }}>
                                                {product.isFree ? (
                                                    <Box>
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                textDecoration: "line-through",
                                                                color: "text.disabled",
                                                                display: "block"
                                                            }}
                                                        >
                                                            £{product.originalPrice.toFixed(2)}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ fontWeight: 600, display: "block" }}>
                                                            Free
                                                        </Typography>
                                                    </Box>
                                                ) : product.isDiscounted ? (
                                                    <Box>
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                textDecoration: "line-through",
                                                                color: "text.disabled",
                                                                display: "block"
                                                            }}
                                                        >
                                                            £{product.originalPrice.toFixed(2)}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ display: "block" }}>
                                                            £{product.unitPrice.toFixed(2)}
                                                        </Typography>
                                                    </Box>
                                                ) : (
                                                    <Typography variant="caption">
                                                        £{product.unitPrice.toFixed(2)}
                                                    </Typography>
                                                )}
                                            </TableCell>
                                            <TableCell align="right" sx={{ fontSize: "0.75rem" }}>
                                                <Typography variant="caption">
                                                    £{product.discount.toFixed(2)}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right" sx={{ fontSize: "0.75rem" }}>
                                                <Typography variant="caption">
                                                    {product.vatAmount.toFixed(2)}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right" sx={{ fontSize: "0.75rem" }}>
                                                <Typography variant="caption">
                                                    £{product.netAmount.toFixed(2)}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 6 }} />
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                                        <Typography variant="caption" sx={{ fontWeight: 600 }}>Total VAT Goods</Typography>
                                        <Typography variant="caption">
                                            £{invoiceData.totals.totalStdGoods.toFixed(2)}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                                        <Typography variant="caption" sx={{ fontWeight: 600 }}>VAT Amount</Typography>
                                        <Typography variant="caption">
                                            £{invoiceData.totals.vatAmount.toFixed(2)}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                                        <Typography variant="caption" sx={{ fontWeight: 600 }}>Total Zero VAT Goods</Typography>
                                        <Typography variant="caption">
                                            £{invoiceData.totals.totalZeroGoods.toFixed(2)}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                                        <Typography variant="caption" sx={{ fontWeight: 600 }}>Promotional Discount</Typography>
                                        <Typography variant="caption">
                                            £{invoiceData.totals.promotionalDiscount.toFixed(2)}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                                        <Typography variant="caption" sx={{ fontWeight: 600 }}>Order Discount</Typography>
                                        <Typography variant="caption">
                                            £{invoiceData.totals.orderDiscount.toFixed(2)}
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ my: 0.5 }} />
                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                                        <Typography variant="caption" sx={{ fontWeight: 600 }}>
                                            Invoice Total
                                        </Typography>
                                        <Typography variant="caption" sx={{ fontWeight: 600 }}>
                                            £{invoiceData.totals.invoiceTotal.toFixed(2)}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>

                        <Box sx={{ mt: 4, textAlign: "center" }}>
                            <Typography variant="caption" sx={{ color: "text.secondary" }}>
                                No claims for damages or short delivery will be considered unless made at the time of delivery of goods. These goods are not sold on a sale or return basis.
                            </Typography>
                        </Box>

                    </Paper>
                </Box>
            </Box>
      
        </div>
    );
};

export default TaxInvoiceView;

